import { forwardRef } from "react";

import { Slot } from "@radix-ui/react-slot";

import { cn } from "../index";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  asChild?: boolean;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ type, asChild, className, ...props }, forwardedRef) => {
  const Comp = asChild ? Slot : "button";
  return (
    <Comp
      {...props}
      ref={forwardedRef}
      type={type ?? "button"}
      className={cn(
        `gap-2.5 font-normal flex cursor-pointer items-center border-none bg-transparent text-base text-primary-blue select-none disabled:cursor-auto disabled:text-primary-dark-gray [&>svg]:shrink-0`,
        className,
      )}
    />
  );
});

Button.displayName = "Button";

export default Button;
export { Button };
export type { ButtonProps };
